import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const LanguageContext = createContext({
  language: 'es',
  setLanguage: () => {},
  toggleLanguage: () => {},
  themeMode: 'dark',
  setThemeMode: () => {},
  toggleThemeMode: () => {}
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem('site-language');
    return stored === 'en' ? 'en' : 'es';
  });
  const [themeMode, setThemeMode] = useState(() => {
    const stored = localStorage.getItem('site-theme-mode');
    return stored === 'light' ? 'light' : 'dark';
  });

  useEffect(() => {
    localStorage.setItem('site-language', language);
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    localStorage.setItem('site-theme-mode', themeMode);
    document.documentElement.setAttribute('data-theme', themeMode);
  }, [themeMode]);

  const value = useMemo(
    () => ({
      language,
      setLanguage,
      toggleLanguage: () => setLanguage((current) => (current === 'es' ? 'en' : 'es')),
      themeMode,
      setThemeMode,
      toggleThemeMode: () => setThemeMode((current) => (current === 'light' ? 'dark' : 'light'))
    }),
    [language, themeMode]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
